import { ExpenseAllTypes } from "./expense.model";

export class Expenses {
    constructor(
        public readonly expenses: ExpenseAllTypes[],
        public readonly count: number,
    ) {}
}
